import React from 'react';
import UploadUsersContainer from './UploadUsersContainer';
import PrivatePageHOC from '../../../containers/PrivatPageHOC/PrivatePageHOC';

const UploadUsers = () => <UploadUsersContainer />;

export default PrivatePageHOC(UploadUsers);
